import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-chapter-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalHeaderComponent,
    LoaderComponent,
  ],
  templateUrl: './chapter-form.component.html',
  styleUrl: './chapter-form.component.scss',
})
export class ChapterFormComponent implements OnInit {
  @Input() item: any = {};
  @Input() productId: any;
  @Input() productSubjects: any = {};
  @Input() modalInstance: any = null;

  modalTitle: string = 'Module toevoegen';
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;
  modalStyle: boolean = false;

  @Input() selectedSubjectId: string = '';
  courseSections: any[] = [];
  selectedChapters: any[] = [];

  searchTerm: string = '';

  constructor(
    private apiService: ApiService,
    public activeModal: NgbActiveModal
  ) {
    this.item = {};
  }
  ngOnInit(): void {
    this.reset();
    this.getItem();

    if (this.selectedSubjectId !== '') {
      this.fetchCourseSections(this.selectedSubjectId);
    }
  }

  canShow(term: string) {
    if (this.searchTerm.length == 0 || term.toLowerCase().includes(this.searchTerm.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  fetchCourseSections(subjectId: string) {
    if (!subjectId) return;

    this.loading = true;
    this.apiService
      .get(`/office/courses/${subjectId}/sections`)
      .then((response: any) => {
        this.courseSections = response.map((section: any) => ({
          ...section,
          checked: false, // Add checked property for binding
        }));
      })
      .catch((error) => {
        this.errorMessage = 'Failed to fetch sections.';
      })
      .finally(() => {
        this.loading = false;
      });
  }

  toggleChapterSelection(chapter: any) {
    if (chapter.checked) {
      this.selectedChapters.push(chapter.id); // Add section ID to array
    } else {
      this.selectedChapters = this.selectedChapters.filter(
        (id) => id !== chapter.id // Remove section ID from array
      );
    }
  }

  addChapters() {
    const selectedData = this.selectedChapters;
    let self = this;
    this.loading = true;
    Promise.all(
      selectedData.map(function (data) {
        self.apiService.post('/office/products/' + self.productId + "/chapters", {
          chapterId: data
        })
      })
    )
      .then(() => {
        setTimeout(() => {
          this.activeModal.close(true);
        }, 300);
      })
      .catch(() => {
        this.errorMessage = 'Failed to save sections.';
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getItem() {
    if (!this.item['id']) return;

    this.loading = true;
    this.apiService
      .get(`/office/products/${this.item['id']}`)
      .then((response: any) => {
        this.item = response;
        this.modalTitle = this.item['id']
          ? 'Wijzig module'
          : 'Module toevoegen';
      })
      .catch(() => {
        this.errorMessage = 'Failed to fetch product details.';
      })
      .finally(() => {
        this.loading = false;
      });
  }
}